/**
 * DIEUKYDIEU.TV - BANNER API SERVICE (js/api/banner.api.js)
 * Fetches dynamic hero banners from Go backend with fallback to static MASTER_BANNERS.
 * Under 300 lines rule compliant.
 */

import { apiClient } from './client.js';
import { API_CONFIG } from './config.js';

export const bannerApi = {
    /**
     * Get active banners from backend API
     * @returns {Promise<Array|null>}
     */
    async getBanners() {
        try {
            const res = await apiClient.get('/banners');
            return (res && res.data !== undefined) ? res.data : res;
        } catch (err) {
            console.warn('[bannerApi] Failed fetching dynamic banners, falling back to static banners:', err.message);
            return null;
        }
    }
};
